/* eslint-disable */
import Swiper from 'swiper/bundle';

class Slider {

  constructor() {

    this.resizeTM = false;
    this.sliders = [];
    this.slidersElements = document.querySelectorAll('.slider');
    this.defaultConfig = {
      a11y:true,
      loop:true,
      slidesPerView:1,
      spaceBetween:15,
      initialSlide:0,
      autoHeight: true,
      autoplay: {delay:3500, disableOnInteraction:true},
      pagination:{el:".swiper-pagination",clickable:true,type:"bullets"},
      navigation:false,
      scrollbar:false,
      keyboard:{enabled:true},
    };

    this.init();

  }

  init() {

    // carica i caroselli
    this.slidersElements.forEach( (el,idx) => {
      this.loadSwiper( idx, el );
      this.breakpointChecker( idx );
    });


    window.addEventListener('resize', () => {

      clearTimeout(this.resizeTM);

      this.resizeTM = setTimeout(() => {
        this.slidersElements.forEach( (el, idx) => {
          this.breakpointChecker( idx );
        })
      }, 250);

    });

  }

  breakpointChecker( slidernum ) {

    if( typeof this.sliders[slidernum] === "undefined" ) {
      return;
    }

    // se matcha la media query allora disattiva il carosello
    if (
      this.sliders[slidernum].breakpoint !== null &&
      this.sliders[slidernum].breakpoint.matches === true
    ) {

      if( this.sliders[slidernum].slider !== null ) {
        this.sliders[slidernum].slider.destroy(true, true);
        this.sliders[slidernum].slider = null;
      }

      this.sliders[slidernum].el.classList.add('slider--disabled');

    }
    // negli altri casi sempre attivo
    else if (
      this.sliders[slidernum].breakpoint === null ||
      this.sliders[slidernum].breakpoint.matches === false
    ) {

      this.sliders[slidernum].el.classList.remove('slider--disabled');

      if ( this.sliders[slidernum].slider === null ) {
        return this.enableSwiper(slidernum);
      }

    }

    return;

  }

  enableSwiper( slidernum ) {

    this.sliders[slidernum].slider = new Swiper(
      this.sliders[slidernum].el,
      this.sliders[slidernum].config
    );

  }

  loadSwiper( slidernum, el ) {

    let configuration = this.defaultConfig;

    // se c'è una configurazione specifica la carico, altrimenti usa default
    if( "sliderConfig" in el.dataset ){
      configuration = JSON.parse( el.dataset.sliderConfig );
    }

    // non c'è navigazione nascondo le frecce
    if( configuration.hasOwnProperty('navigation') &&
      configuration.navigation === false
    ) {

      // nascondo le frecce
      el.querySelector('.swiper-button-next').classList.add('d-none');
      el.querySelector('.swiper-button-prev').classList.add('d-none');

    }

    if( configuration.hasOwnProperty('pagination') &&
      configuration.pagination === false
    ) {

      // nascondo i pallini
      el.querySelector('.swiper-pagination').classList.add('d-none');

    }

    if( configuration.hasOwnProperty('scrollbar') &&
      configuration.scrollbar === false
    ) {

      // nascondo la scrollbar
      el.querySelector('.swiper-scrollbar').classList.add('d-none');

    }

    // null = carosello sempre attivo
    const breakpoint = ("sliderDestroyBreakpoint" in el.dataset) ? el.dataset.sliderDestroyBreakpoint : null;

    if(
      configuration.hasOwnProperty('on') &&
      configuration.on.hasOwnProperty('init')
    ) {
      configuration.on.init = this[configuration.on.init].bind(this);
    }

    // console.log('slide config');
    // console.log(configuration);

    this.sliders[slidernum] = {
      el:el,
      config: configuration,
      // breakpoint minimo superato il quale il carosello verrà disattivato
      breakpoint: breakpoint !== null ? window.matchMedia( '(min-width:'+breakpoint+')' ) : null,
      slider: null
    };

  }


  reloadCursor() {
    window.sf.cursor.init();
  }


}

export default Slider;



// WEBPACK FOOTER //
// ./scripts/classes/slider.js